import { Navigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

export default function SellerRouteGuard({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F4F7F6]">
        <div className="text-sm text-[#66766D]">
          Checking partner access...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/vendor/login" replace />;
  }

  if (user.role !== "vendor") {
    return <Navigate to="/" replace />;
  }

  return children;
}
